import { FaRegUser, FaRegImages, FaRegImage, FaRegBell } from "react-icons/fa";
import { FiLogOut, FiMenu, FiChevronRight } from "react-icons/fi";
import { MdOutlineLanguage } from "react-icons/md";
import { FaImages } from "react-icons/fa";
import { RiImageAddLine } from "react-icons/ri";
import {
    HiOutlineUsers,
    HiOutlineArrowNarrowUp,
    HiOutlineUserAdd,
    HiOutlineArrowNarrowDown,
    HiChevronRight,
    HiChevronLeft,
    HiChevronDown,
} from "react-icons/hi";
import {
    AiOutlineInfoCircle,
    AiOutlineDashboard,
    AiOutlineAppstore,
    AiOutlineAppstoreAdd,
    AiOutlineFileProtect,
    AiOutlineFileText,
    AiOutlineFileSearch,
    AiOutlineDollar,
    AiFillEyeInvisible,
    AiFillEye,
    AiOutlineSearch,
} from "react-icons/ai";
import { BiPlusCircle, BiSortAlt2 } from "react-icons/bi";
export const icon = {
    user: <FaRegUser />,
    FaImages:<FaImages />,
    addImage:<RiImageAddLine/>,
    logout: <FiLogOut />,
    chevronR: <FiChevronRight />,
    menu: <FiMenu />,
    lang: <MdOutlineLanguage />,
    dashboard: <AiOutlineDashboard />,
    products: <AiOutlineAppstore />,
    addProduct: <AiOutlineAppstoreAdd />,
    orders: <AiOutlineFileText />,
    ordersAll: <AiOutlineFileProtect />,
    archiveOrders: <AiOutlineFileSearch />,
    users: <HiOutlineUsers />,
    addUser: <HiOutlineUserAdd />,
    dollar: <AiOutlineDollar />,
    eyeShow: <AiFillEye />,
    search: <AiOutlineSearch />,
    eyeHide: <AiFillEyeInvisible />,
    sortUp: <HiOutlineArrowNarrowUp />,
    sortDown: <HiOutlineArrowNarrowDown />,
    unsorted: <BiSortAlt2 />,
    chevronRight: <HiChevronRight />,
    chevronLeft: <HiChevronLeft />,
    chevronDown: <HiChevronDown />,
    info: <AiOutlineInfoCircle />,
    popup: <FaRegBell />,
    addPopup: <BiPlusCircle />,
    ads: <FaRegImages />,
    addAds: <FaRegImage />,
};
